import React, {useState} from 'react'
import UsersModal from './UsersModal'
import card from '../images/card.svg'

const CardMap = ({game}) => {
  const [selectedPosition, setSelectedPosition] = useState('')

  const getPosition = (position) => {
    switch (position) {
      case 'OP':
        return 'ОП'
      case 'CPR':
        return 'ЦАП'
      case 'CPL':
        return 'ЦП'
      case 'LP':
        return 'ЛВ'
      case 'PP':
        return 'ПВ'
      case 'CZP':
        return 'ПЦЗ'
      case 'CZL':
        return 'ЛЦЗ'
      case 'LZ':
        return 'ЛЗ'
      case 'PZ':
        return 'ПЗ'
      case 'V':
        return 'В'
      case 'N':
        return 'Н'
      default:
        return ''
    }
  }

  return (
    <div
      className={`game-card game-card--${game.pos}`}
      onClick={() => {
        setSelectedPosition(game.pos)
      }}
    >


      {selectedPosition === game.pos && <UsersModal players={game.players}
                                                    selectedPosition={selectedPosition}
                                                    setSelectedPosition={setSelectedPosition}/>}

      <img src={card} alt=""/>
      <div className="game-card__players">

        <div className="game-card__helper">
          {getPosition(game.pos)}
        </div>

        {
          game.players ? game.players.map((player, index) => <p key={player.id}>
            {index + 1} {player.players.lastname}
          </p>) : <span>?</span>
        }
      </div>
    </div>
  )
}

export default CardMap
